import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { IChecklistV2ReportParameter, IChecklistV2ReportParameterFilter } from '../../../shared/fi-checklist2-report';
import { IChecklist2ReportViewData } from '../../../shared/fi-checklist2-report-data';
import { FiChecklist2ReportHelperService } from '../../../services/fi-checklist2-report-helper.service';
import { NewWidgetFilterSettingsDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-filter-settings-dialog-base';
import { FiChecklist2ReportType } from '../../../enums/fi-checklist2-report-type';
import { AppTextService } from '@fi-shared/app-text';
@Component({
    selector: 'fi-checklist2-report-new-widget-data-filter-step',
    templateUrl: 'new-widget-data-filter-step.component.html',
    styleUrls: ['./new-widget-data-filter-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-report-new-widget-data-filter-step' },
    standalone: false,
})
export class FiChecklist2ReportNewWidgetDataFilterStepComponent extends NewWidgetFilterSettingsDialogBaseDirective<
    IChecklistV2ReportParameterFilter,
    FiChecklist2ReportType,
    IChecklistV2ReportParameter
> {
    public reportData = input.required<IChecklist2ReportViewData>();

    private readonly appTextService = inject(AppTextService);
    private readonly fiChecklist2ReportHelperService = inject(FiChecklist2ReportHelperService);

    protected widgetName = computed(() =>
        this.appTextService.get(
            this.fiChecklist2ReportHelperService.widgetNameByReportTypeMap[this.reportWidget().ReportType],
        ),
    );
}
